import type { Supplier } from "@/models/supplier";

import axios from "axios";

export const deleteSupplier = async (supplier: Supplier): Promise<void> => {
  const resp = await axios.delete("/api/supplier", {
    data: supplier,
  });
  return resp.data;
};

export const addSupplier = async (supplier: Supplier): Promise<void> => {
  const resp = await axios.post("/api/supplier", supplier);
  return resp.data;
};
